import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg width="60" height="58" viewBox="0 0 60 58" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-10 -11)" fill="none" fillRule="evenodd">
        <path d="M0 0h80v80H0" />
        <circle fill="#44484C" fillRule="nonzero" cx="46.26" cy="57.62" r="2" />
        <rect stroke="#44484C" x="11" y="47.62" width="44.26" height="20" rx="2" />
        <path d="M18 47.62v-9.98m17 18.98v2m-8-2v2m-8-2v2" stroke="#44484C" strokeLinecap="round" />
        <circle fill="#44484C" fillRule="nonzero" cx="59.98" cy="43.9" r="2" />
        <path d="M24.72 47.52V37.9c0-2.21 1.79-4 4-4h36.26c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4h-9.64" stroke="#44484C" />
        <path d="M31.72 33.9v-10" stroke="#44484C" strokeLinecap="round" />
        <path d="M22.72 16c2.298-2.548 5.57-4.002 9-4.002 3.43 0 6.702 1.454 9 4.002m-14 4c2.802-2.662 7.198-2.662 10 0" strokeLinecap="round" stroke="#000" />
      </g>
    </svg>
  </span>
);

export default icon;
